// extracted by mini-css-extract-plugin
export var section = "styles-module--section--2ooKH";
export var container = "styles-module--container--436Qy";
export var iconContentContainer = "styles-module--iconContentContainer--3Ta6a";
export var icon = "styles-module--icon--2FtNz";
export var content = "styles-module--content--2mWFR";